<script lang="ts" setup>
import IconMissingImage from "@/components/icons/IconMissingImage.vue";

interface Properties {
  imageUrl?: string;
  alt: string;
}

defineProps<Properties>();
</script>

<template>
  <div class="w-[100px] h-[100px] min-w-[100px] min-h-[100px] border border-gray-300">
    <img v-if="imageUrl" :alt="alt"
         :src="imageUrl" class="relative left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 max-w-[99px] max-h-[99px]" crossorigin="anonymous">
    <IconMissingImage v-else></IconMissingImage>
  </div>
</template>
